import { APIMethod, fetchData } from "@client";

export async function cancelSubscriptionQuery() {
  return await fetchData("/order/subscription", APIMethod.DELETE);
}
